import { useFormikContext, getIn } from 'formik'
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useDeleteChecklistMutation } from 'apiv2'
import { taskModalSelector, openTaskModalAction } from 'store/modals'
import { getTaskDetailAction } from 'store/tasks'
import ButtonMoreActions from 'ui/components/buttons/ButtonMoreActions'
import Checkbox from 'ui/components/forms/Checkbox'
import Input from 'ui/components/forms/Input/'
import ConfirmModal from 'ui/components/modals/ConfirmModal'
import { notifySuccess, notifyError } from 'ui/components/Notify'
import { TASK_TYPE } from 'utils/constants'
import ChecklistItemMenuActions from '../ChecklistItemMenuActions'
import { ChecklistItemWrap, CheckboxWrap, ChecklistPointer } from './styled'
import { CHECKLIST_VARIANT } from '../../constants'
import { moveInArray, deleteInArray } from '../../helpers'

const { TASK } = CHECKLIST_VARIANT

const ChecklistItem = ({
  checklistIndex,
  pointIndex,
  copyPoint,
  variant,
  onMenuOpenChange = () => {},
}) => {
  const dispatch = useDispatch()
  const formik = useFormikContext()
  const [confirmOpened, setConfirmOpened] = useState(false)
  const displayIndex = pointIndex + 1
  const pointsPath = `checklists.${checklistIndex}.points`
  const pointPath = `checklists.${checklistIndex}.points.${pointIndex}`
  const textPath = `${pointPath}.text`
  const isDonePath = `${pointPath}.is_done`
  const text = getIn(formik.values, textPath)
  const isDone = getIn(formik.values, isDonePath)
  const points = getIn(formik.values, pointsPath) || []
  const isNotNewPoint = !!getIn(formik.values, pointPath)?.id
  const isTaskVariant = variant === TASK
  const { defaultTaskDetails } = useSelector(taskModalSelector)
  const [deleteChecklist] = useDeleteChecklistMutation()
  const isNotNewTask = isTaskVariant && !!defaultTaskDetails
  const canCreateSubtask =
    isTaskVariant && !!defaultTaskDetails && isNotNewPoint

  const updateTask = () => {
    dispatch(getTaskDetailAction(defaultTaskDetails?.id))
  }

  const movePoint = (from, to) => {
    if (to < 0 || to >= points.length || from === to) return
    const next = moveInArray(points, from, to)
    formik.setFieldValue(pointsPath, next)
  }

  const moveUp = () => movePoint(pointIndex, pointIndex - 1)

  const moveDown = () => movePoint(pointIndex, pointIndex + 1)

  const deletePoint = (index) => {
    if (index < 0 || index >= points.length) return
    const next = deleteInArray(points, index)
    if (next.length === 0) {
      setConfirmOpened(true)
    } else {
      formik.setFieldValue(pointsPath, next)
    }
  }

  const handlerDeleteChecklist = async (checklistIndex) => {
    const lists = getIn(formik.values, 'checklists') ?? []
    const newLists = deleteInArray(lists, checklistIndex)
    if (isNotNewTask && Boolean(lists[checklistIndex]?.id)) {
      try {
        await deleteChecklist({
          itemId: lists[checklistIndex].id,
        }).unwrap()
        formik.setFieldValue('checklists', newLists)
        notifySuccess('Чек-лист удален')
        dispatch(getTaskDetailAction(defaultTaskDetails?.id))
      } catch (error) {
        notifyError('Ошибка удаления чек-листа')
      } finally {
        setConfirmOpened(false)
      }
    } else {
      formik.setFieldValue('checklists', newLists)
      setConfirmOpened(false)
      if (isNotNewTask) {
        notifySuccess('Чек-лист удален')
      }
    }
  }

  const addSubtaskOpen = () => {
    dispatch(
      openTaskModalAction({
        eventType: 'create',
        defaultType: TASK_TYPE.Task,
        updateRequest: updateTask,
        defaultTaskDetails: {
          id: defaultTaskDetails.id,
          task_type: defaultTaskDetails.task_type,
        },
        title: 'Создать подзадачу',
        checklistPointTitle: text,
      })
    )
  }

  return (
    <>
      <ChecklistItemWrap
        isDone={isDone && formik.getFieldProps(textPath).value}
      >
        <CheckboxWrap>
          <Checkbox
            checked={formik.getFieldProps(isDonePath).value}
            {...formik.getFieldProps(isDonePath)}
          />
        </CheckboxWrap>
        <ChecklistPointer>{displayIndex}</ChecklistPointer>
        <Input
          id={`checklistItemInput-${checklistIndex}-${pointIndex}`}
          placeholder="Название пункта"
          name={textPath}
          {...formik.getFieldProps(textPath)}
          meta={formik.getFieldMeta(textPath)}
        />
        <ButtonMoreActions menuPosition="right" onOpenChange={onMenuOpenChange}>
          {({ close }) => (
            <ChecklistItemMenuActions
              canCreateSubtask={canCreateSubtask}
              onMoveUp={moveUp}
              onMoveDown={moveDown}
              onCopy={() => copyPoint(text)}
              onCreateSubtask={addSubtaskOpen}
              onDelete={() => deletePoint(pointIndex, checklistIndex)}
              close={close}
            />
          )}
        </ButtonMoreActions>
      </ChecklistItemWrap>
      <ConfirmModal
        title="Вы уверены, что хотите удалить чек-лист?"
        open={confirmOpened}
        confirmHandler={async () => {
          await handlerDeleteChecklist(checklistIndex)
        }}
        handlerClose={() => setConfirmOpened(false)}
      />
    </>
  )
}

export default ChecklistItem
